import { useTranslation } from 'react-i18next';
import AssistanceSection from '../../../document/pages/Assistance/AssistanceSection.tsx';
import * as React from 'react';
import { withIcon } from '../../../core/components/Icon.tsx';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

const CompleteIcon = withIcon(faCheckCircle);

const CompleteButton = ({
    isComplete,
    onIsCompleteChange,
    disabled,
}: {
    isComplete: boolean;
    onIsCompleteChange?: any;
    disabled?: boolean;
}) => {
    const { t } = useTranslation('assistance');

    return isComplete ? (
        <span className="text-sm font-medium text-content-strong flex gap-1.5 items-center px-2">
            <CompleteIcon className="text-content-success-strong" />
            {t('itemsView.actions.sectionCompleted')}
        </span>
    ) : (
        <AssistanceSection.IconButton
            className="bg-surface-brand-strong-default hover:bg-surface-brand-strong-hover active:bg-surface-brand-strong-active text-content-white dark:text-content-black hover:text-content-white dark:text-content-black disabled:opacity-50 disabled:pointer-events-none"
            onClick={() => onIsCompleteChange?.(true)}
            disabled={disabled}
        >
            <CompleteIcon />
        </AssistanceSection.IconButton>
    );
};

export default CompleteButton;
